export default ['Alaska', 'Tennessee', 'Wyoming',  'Florida', 'New Hampshire', 'South Dakota', 'Texas', 'Washington', 'Nevada'];